import { transparentize } from "@glossy";

const positive = "rgb(31,170,122)";
const negative = "rgb(230,76,101)";

// Clamp the value within a valid range
const v = (value: number) => Math.min(1, Math.max(0, value));

export const ChartPolarizeColors = {
  id: "chartPolarizeColors",
  beforeRender: function (chart) {
    const dataset = chart.data.datasets[0];

    const yScale = chart.scales["y"];
    const yPosition = yScale.getPixelForValue(0);

    const gradientFill = chart.ctx.createLinearGradient(0, 0, 0, chart.height);
    gradientFill.addColorStop(0, transparentize(0.7, positive));
    gradientFill.addColorStop(
      v(yPosition / chart.height - 0.01),
      transparentize(0.7, positive)
    );
    gradientFill.addColorStop(
      v(yPosition / chart.height + 0.01),
      transparentize(0.7, negative)
    );
    gradientFill.addColorStop(1, transparentize(0.7, negative));

    const strokeFill = chart.ctx.createLinearGradient(0, 0, 0, chart.height);
    strokeFill.addColorStop(0, positive);
    strokeFill.addColorStop(v(yPosition / chart.height - 0.01), positive);
    strokeFill.addColorStop(v(yPosition / chart.height + 0.01), negative);
    strokeFill.addColorStop(1, negative);

    dataset.backgroundColor = gradientFill;
    dataset.borderColor = strokeFill;
  },
};
